import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import type { Ota } from 'frontend-utils/models';
import type { PeriodParity, PeriodRate } from 'lumen/models/period';
import {
  MEALTYPE_ICONS,
  type MealTypeValues,
  RATE_PARAMS,
  type RateParam,
  THIRD_PARTY_LABEL,
} from 'lumen/utils/constants/general-constants';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function getRateIcons(
  rate: PeriodRate | PeriodParity | undefined,
  rateParam: RateParam,
  ota: Ota | null,
  mealPlan: MealTypeValues,
) {
  const rateIcons: IconName[] = [];

  // RateType icons
  if (rate?.labels && rate?.labels?.includes(THIRD_PARTY_LABEL)) {
    // Show 3rd Party icon for 3rd Party rates
    rateIcons.push('rates-third-party');
  } else if (rateParam !== RATE_PARAMS.BEST_FLEX && rate?.best_flex) {
    // Show Best Flex icon when Best Flex isn't selected
    rateIcons.push('rates-best-flex');
  } else if (rateParam === RATE_PARAMS.LOWEST && rate?.cancellable) {
    if (ota?.hasFlexibleFilter) {
      // Show Flexible icon for Flexible rates when Lowest is selected
      rateIcons.push('rates-semi-flex');
    }
  }

  // Member Only icon
  if (rate?.membershiptype && rate?.membershiptype > 0) {
    rateIcons.push('user');
  }

  // Mealtype icons
  // Fix for when the rate is a Ember object (camelCase instead of snake_case)
  const mealTypeIncluded = rate?.mealtype_included || rate?.mealtypeIncluded;
  let mealTypeIcon = undefined;
  if (mealTypeIncluded) {
    mealTypeIcon = MEALTYPE_ICONS[mealTypeIncluded];
  }

  // Only show the meal types that aren't selected
  if (mealTypeIncluded !== mealPlan && mealTypeIcon) {
    rateIcons.push(mealTypeIcon);
  }

  return rateIcons;
}

export default getRateIcons;
